var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartners(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11 4.1819L7.12089 8.83685C6.79679 9.22577 6.21877 9.27832 5.82985 8.95422C5.44093 8.63012 5.38839 8.0521 5.71249 7.66318L10.2958 2.16318C10.6623 1.72341 11.3377 1.72341 11.7042 2.16318L16.2876 7.66318C16.6117 8.0521 16.5591 8.63012 16.1702 8.95422C15.7813 9.27832 15.2033 9.22577 14.8792 8.83685L11 4.1819Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7211 8.25C4.00398 8.25 3.51996 8.98257 3.80123 9.64223L6.55593 16.1026C7.02742 17.2084 8.11345 17.9259 9.31553 17.9259H12.6844C13.8866 17.9259 14.9727 17.2083 15.4441 16.1024L18.1982 9.64216C18.4794 8.98251 17.9953 8.25 17.2783 8.25H4.7211ZM12.8333 13.75C12.8333 14.7625 12.0125 15.5833 11 15.5833C9.98743 15.5833 9.16662 14.7625 9.16662 13.75C9.16662 12.7375 9.98743 11.9167 11 11.9167C12.0125 11.9167 12.8333 12.7375 12.8333 13.75Z",
    fill: "#212121"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartners);
export default __webpack_public_path__ + "static/media/partners.996f04fa7238f9e4b3508dd1c604f3ab.svg";
export { ForwardRef as ReactComponent };